import { Component, ViewChild, ElementRef, Renderer } from '@angular/core';
import { NavController, NavParams, Events, PopoverController, Slides } from 'ionic-angular';
import { ApiProvider } from '../../providers/api/api';
import { CommonProvider } from '../../providers/common/common';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommonHeaderComponent } from '../../components/common-header/common-header';
import { CommonFooterComponent } from '../../components/common-footer/common-footer';
import { BgColorDirective } from '../../directives/bg-color/bg-color';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})

export class HomePage {
  is_pc:boolean;
  service_data = [];
  user_data = [];
  is_login:boolean;
  slide_list = [];
  slide_config = {autoplay:0,pager:false,loop:false};
  push_list = [];
  push_count:number;
  is_disp_push:boolean;
  event_list = [];
  event_count:number;
  is_disp_event:boolean;
  coupon_list = [];
  coupon_count:number;
  is_disp_coupon:boolean;
  menu_all = [];  
  screen_list = [];
  home_disp:SafeHtml;
  home_body:string;
  slide_set_time = 300;
  slide_height = '400px';
  monthly_ranking = [];
  is_user_stage:boolean = false;
  color_list = {};
  top_movie_data = [];
  home_rss_ids = [];
  @ViewChild(CommonHeaderComponent) comHeader: CommonHeaderComponent;
  @ViewChild(CommonFooterComponent) comFooter: CommonFooterComponent;
  @ViewChild(BgColorDirective) bgCol: BgColorDirective;
  @ViewChild('slides_top') slides_top: Slides;
  push_pop = [];
  is_home_iframe:boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    public apiProv: ApiProvider,
    public comProv: CommonProvider,
    public gaProv: AnalyticsProvider,
    public sanitizer: DomSanitizer,
    private el: ElementRef,
    private renderer: Renderer,
    public popoverCtrl: PopoverController,
  ) {
    if (this.comProv.isTablet()) {
      this.slide_height = '800px';
    }
    this.is_pc = this.comProv.isPc();
    this.events.subscribe('home:pc', () => {
      this.setPc();
    });

    if (this.navParams.get('scroll_id')) {
      this.slide_set_time = 10;
      setTimeout(() => {
        this.scrollTo(this.navParams.get('scroll_id'));
      }, 100)
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HomePage');
    this.start();
    if (this.navCtrl['rootParams']['is_pc_start']) {
      this.setPc();
    }
  }

  start() {
    if (this.navParams.get('is_loader')) {
      this.apiProv.dispLoader();
    }
    this.service_data = this.comProv.getService();
    this.is_login = this.comProv.isLogin();
    this.getTopTab();

    this.home_body = localStorage.getItem('home_body');
    this.setHome();
    this.setSlide();
    this.color_list = this.comProv.getColor();

    if (this.is_login && !this.is_pc) {
      this.user_data = this.comProv.getUser();
      this.getMonthlyRanking();

      let last_push_unread_time = this.comProv.getOptionsValue('last_push_unread_time');
      let check_date = new Date();
      check_date.setMinutes(check_date.getMinutes() - 10);
      let is_push_interval = this.comProv.checkTime(last_push_unread_time, null, check_date);
      //is_push_interval = true;
      if (is_push_interval) {
        this.getPush();
        this.comProv.setOptions('last_push_unread_time', this.comProv.formatDate(new Date(), 'YYYY/MM/DD hh:mm:ss'));
      } else {
        this.setNewPush(this.comProv.getOptionsValue('unread_total'));
      }
    }

    this.top_movie_data = this.service_data['top_movie'];
    if (this.top_movie_data['vimeo_id'] && !this.top_movie_data['is_privated']) {
      this.top_movie_data['is_display'] = true;
      let src = 'https://player.vimeo.com/video/' + this.top_movie_data['vimeo_id'] + '/?controls=0&autoplay=1&muted=1&loop=' + this.top_movie_data['is_loop'];
      this.top_movie_data['src'] = this.sanitizer.bypassSecurityTrustResourceUrl(src);
      this.top_movie_data['style_padding'] = this.top_movie_data['aspect_ratio'] + '% 0 0 0';
    }

    try {
      if (!this.is_pc) {
        this.bgCol.setColor();
      }
      this.comHeader.setHeader();
      this.comFooter.setList();
    } catch(e) {
      console.log(e);
    }

    let bg_color = '#ffffff';
    if (localStorage.getItem('base_data') && localStorage.getItem('base_data') != '') {
      let base_data = JSON.parse(localStorage.getItem('base_data'));
      if (base_data['background_color']) {
        bg_color = base_data['background_color'];
      }
    }
    this.renderer.setElementStyle(this.el.nativeElement, 'backgroundColor', bg_color);
    if (this.navParams.get('is_loader')) {
      setTimeout(() => {
        this.apiProv.removeLoader();
      }, 100)
    }
  }

  setPc() {
    if (!this.is_pc) {
      return;
    }

    let drawer_list = this.comProv.getDrawer();
    drawer_list.forEach(function(item) {
      if (item['page_target'] == 'PushIndexPage' && !item['is_privated']) {
        this.is_disp_push = true;
      }
      if (item['page_target'] == 'CouponIndexPage' && !item['is_privated']) {
        this.is_disp_coupon = true;
      }
      if (item['page_target'] == 'EventIndexPage' && !item['is_privated']) {
        this.is_disp_event = true;
      }
    }, this);

    if (this.navCtrl['rootParams']['push_list']) {
      let push_list = this.navCtrl['rootParams']['push_list'];
      this.push_list = push_list.slice(0,5);
      this.push_count = this.push_list.length;
    }

    if (this.event_list.length < 1) {
      if (this.navCtrl['rootParams']['event_list']) {
        this.event_list = this.navCtrl['rootParams']['event_list'];
        this.event_count = this.event_list.length;

        if (this.event_count > 0) {
          let event_loop = 0;
          let set_event_height = setInterval(() => {
            let is_event_img = true;
            this.event_list.forEach(function(item, index) {
              let event_img = document.getElementById('event_img_' + index) as HTMLImageElement;
              if (!event_img) {
                is_event_img = false;
              } else {
                if (!event_img.naturalHeight) {
                  is_event_img = false;
                }
              }
            });

            if (is_event_img || event_loop > 20) {
              clearInterval(set_event_height);
              $('.event_slide').slick({
                slidesToShow: 3,
                adaptiveHeight: true,
                arrows: false,
                dots: true,
                infinite: false
              });
              $('.matchHeight').matchHeight();
            }
            ++event_loop;
          }, 50)
        }
      }
    }

    if (this.coupon_list.length < 1) {
      if (this.navCtrl['rootParams']['coupon_list']) {
        this.coupon_list = this.navCtrl['rootParams']['coupon_list'];
        this.coupon_count = this.coupon_list.length;

        if (this.coupon_count > 0) {
          let coupon_loop = 0;
          let set_coupon_height = setInterval(() => {
            let is_coupon_img = true;
            this.coupon_list.forEach(function(item, index) {
              let coupon_img = document.getElementById('coupon_img_' + index) as HTMLImageElement;
              if (!coupon_img) {
                is_coupon_img = false;
              } else {
                if (!coupon_img.naturalHeight) {
                  is_coupon_img = false;
                } 
              }
            });

            if (is_coupon_img || coupon_loop > 20) {
              clearInterval(set_coupon_height);
              $('.coupon_slide').slick({
                slidesToShow: 4,
                adaptiveHeight: true,
                arrows: false,
                dots: true,
                infinite: false
              });
              $('.matchHeight').matchHeight();
            }
            ++coupon_loop;
          }, 50)
        }
      }
    }

    if (this.navCtrl['rootParams']['menu_all']) {
      this.menu_all = this.navCtrl['rootParams']['menu_all'];

      for (let i=0; i<this.menu_all.length; i++) {
        this.dispMenu(i, 0);
      }
    }

    if (this.screen_list.length < 1) {
      let screenshot = this.service_data['android_screenshot'];
      let screen_list = [];
      if (screenshot) {
        for (let i=1; i<=5; i++) {
          let line = {
            image_url: screenshot['android_screenshot_phone_' + i],
          };
          if (!line['image_url']) {
            continue;
          }
          screen_list.push(line);
        }
      }
      this.screen_list = screen_list;
      if (this.screen_list.length > 0) {
        try {
          setTimeout(() => {
            $('.apps_slide').slick({
              slidesToShow: 2,
              adaptiveHeight: true,
              arrows: false,
              dots: true,
              infinite: false
            });
          }, this.slide_set_time)
        } catch(e) {
          console.log(e);
        }
      }
    }
  }

  dispMenu(tid, cid) {
    if (!this.menu_all[tid]) {
      return;
    }

    let disp_menus = [];
    if (this.menu_all[tid]['categories']) {
      if (this.menu_all[tid]['categories'][cid]) {
        if (this.menu_all[tid]['categories'][cid]['menus']) {
          disp_menus = this.menu_all[tid]['categories'][cid]['menus'];
        }
      }
    }

    this.menu_all[tid]['active']     = cid;
    this.menu_all[tid]['disp_menus'] = disp_menus;
    this.menu_all[tid]['disp_count'] = disp_menus.length;
  }

  setHome() {
    this.home_disp = this.sanitizer.bypassSecurityTrustHtml(this.home_body);
    // RSS
    if (this.service_data['option']['is_rss_feed']) {
      if (localStorage.getItem('home_rss_ids')) {
        this.home_rss_ids = JSON.parse(localStorage.getItem('home_rss_ids'));
      }
    }

    setTimeout(() => {
      // スライド
      let slide_row_no = this.comProv.getOptionsValue('slide_row_no');
      let slide_rows_el = document.getElementsByClassName('slide-row');
      let slide_marker_el = slide_rows_el[0];

      if (slide_row_no > 1) {
        let top_menu_el = document.querySelector('#topmenu');
        let slide_el = document.querySelector('#top');

        if (top_menu_el && slide_marker_el && slide_el) {
          top_menu_el.insertBefore(slide_el, slide_marker_el);
        }
      }
      if (slide_marker_el) {
        slide_marker_el.remove();
      }

      // iframe
      let home_iframe_url = this.comProv.getOptionsValue('home_iframe_url');
      let iframe_rows_el = document.getElementsByClassName('iframe-row');
      let iframe_marker_el = iframe_rows_el[0];

      if (home_iframe_url) {
        this.is_home_iframe = true;
        let top_menu_el = document.querySelector('#topmenu');
        let iframe_el = <HTMLInputElement>document.querySelector('#home_iframe');
        iframe_el.src = home_iframe_url;

        if (top_menu_el && iframe_marker_el && iframe_el) {
          top_menu_el.insertBefore(iframe_el.parentNode, iframe_marker_el);
        }
      }
      if (iframe_marker_el) {
        iframe_marker_el.remove();
      }

      this.setClick();
    }, 1)
  }

  setClick() {
    var that = this;
    let homes_el = document.getElementsByClassName('home');
    if (homes_el) {
      for (let i = 0; i < homes_el.length; i++ ) {
        let one_el:HTMLInputElement = <HTMLInputElement>homes_el[i];

        one_el.onclick = function () {
          let page_name = one_el.getAttribute('value');
          let data = {
            url: '',
            target: page_name,
            current_page: 'HomePage',
            category: 'ホーム画面ボタン'
          };
          that.comProv.goPage(data, that.navCtrl, that.gaProv);
        }
      }
    }

    let web_el = document.getElementsByClassName('web');
    if (web_el) {
      for (let i = 0; i < web_el.length; i++ ) {
        let one_el:HTMLInputElement = <HTMLInputElement>web_el[i];

        one_el.onclick = function () {
          let link_url = one_el.getAttribute('value');
          let data = {
            url: link_url,
            target: 'Web',
            current_page: 'HomePage',
            category: 'ホーム画面ボタン'
          };
          that.comProv.goPage(data, that.navCtrl, that.gaProv);
        }
      }
    }
  }

  setSlide() {
    if (this.slide_list.length > 0) {
      return;
    }
    if (this.navCtrl['rootParams']['slide_list']) {
      this.slide_list = this.navCtrl['rootParams']['slide_list'];
    }
    if (!this.slide_list) {
      return;
    }
    if (!this.is_pc) {
      if (this.slide_list.length >= 2) {
        this.slide_config['autoplay'] = 2000;
        this.slide_config['pager']    = true;
        this.slide_config['loop']     = true;
      }
      var set_height = setInterval(() => {
        let max_rate = 0;
        let is_set = true;
        this.slide_list.forEach(function(item, index) {
          let slide_img = document.getElementById('slide_img_' + index) as HTMLImageElement;
          if (!slide_img) {
            is_set = false;
          } else {
            if (!slide_img.naturalHeight || !slide_img.naturalWidth) {
              is_set = false;
            } else {
              let img_rate = slide_img.naturalHeight / slide_img.naturalWidth;
              if (img_rate > max_rate) {
                max_rate = img_rate;
              }
            }
          }
        });
        if (is_set) {
          clearInterval(set_height);
          this.slide_height = String(window.parent.screen.width * max_rate) + 'px';
        }
      }, 50)
    }

    if (this.slide_list.length > 0 && this.is_pc) {
      try {
        setTimeout(() => {
          $('.main_slide').slick({
            autoplay: true,
            centerMode: true,
            centerPadding: '27vw',
            arrows: false,
            dots: true,
            responsive: [
                {
                  breakpoint: 2080,
                  settings: {
                    centerPadding: '24vw',
                  }
                },
                {
                  breakpoint: 1880,
                  settings: {
                    centerPadding: '21vw',
                  }
                },
                {
                  breakpoint: 1680,
                  settings: {
                    centerPadding: '17vw',
                  }
                },
                {
                  breakpoint: 1480,
                  settings: {
                    centerPadding: '13vw',
                  }
                },
                {
                  breakpoint: 1281,
                  settings: {
                    centerPadding: '8vw',
                  }
                },
            ]
          });
        }, this.slide_set_time)
      } catch(e) {
        console.log(e);
      }
    }
  }

  getMonthlyRanking() {
    if (this.is_pc || !this.is_login) {
      return;
    }
    if (!this.service_data['is_score'] || !this.service_data['score_is_publiced']) {
      return;
    }
    this.getStageGuide();

    let url = this.service_data['_links']['score']['user_monthly_ranking']['href'];
    let url_req = url.replace('##summary_in##', '');

    this.apiProv.get(url_req)
    .then(data => {
      if (data['statusCode'] != '000') {
        this.apiProv.detaError(data);
        return;
      }
      this.monthly_ranking = this.comProv.addMonthlyRanking(data['data']);
    }).catch(error => {
      this.apiProv.statusError(error, this.navCtrl);
      //this.monthly_ranking = this.comProv.addMonthlyRanking([]);
    });
  }

  getStageGuide() {
    this.apiProv.get(this.service_data['_links']['score']['stage_guide']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        this.apiProv.detaError(data);
        return;
      }
      let stage_guide = data['data'];

      if (this.service_data['is_score'] && 
          this.service_data['score_is_publiced'] && 
          this.user_data['stage_name'] && 
          this.user_data['stage_image_url'] && 
          stage_guide['is_used'] && 
          stage_guide['stages'].length) {
        this.is_user_stage = true;
      }
    }).catch(error => {
      this.apiProv.statusError(error, this.navCtrl);
    });
  }

  getPush() {
    this.apiProv.get(this.service_data['_links']['notifications']['href'])
    .then(data => {
      if (data['statusCode'] != '000') {
        this.apiProv.detaError(data);
        return;
      }
      let unread_total = 0;
      let push_list = data['data'];
      let last_push_pop_time = this.comProv.getOptionsValue('last_push_pop_time');
      let str_today = this.comProv.formatDate(new Date(), 'YYYYMMDD');

      for (let i=0; i<push_list.length; i++) {
        if (!push_list[i]['is_read']) {
          ++unread_total;
          if (this.push_pop.length >= 3) {
            continue;
          }
          if (!push_list[i]['popup_days']) {
            continue;
          }
          if (!this.comProv.checkTime(last_push_pop_time, push_list[i]['delivery_start_at'])) {
            continue;
          }

          let obj_popup_day = new Date(push_list[i]['delivery_start_at'].replace(/-/g, '/'));
          obj_popup_day.setDate(obj_popup_day.getDate() + (push_list[i]['popup_days'] - 1));
          let str_popup_day = this.comProv.formatDate(obj_popup_day, 'YYYYMMDD');
          if (str_popup_day < str_today) {
            continue;
          }

          this.push_pop.push(push_list[i]);
        }
      }

      this.setNewPush(unread_total);
      this.dispPushPop();
    }).catch(error => {
      console.log('error', error);
    });
  }

  setNewPush(unread_total) {
    if (!unread_total || unread_total < 0) {
      unread_total = 0;
    }
    this.comHeader.setPush(unread_total);
    this.comProv.setBadge(unread_total);
    this.comProv.setOptions('unread_total', unread_total);
  }

  dispPushPop() {
    if (this.is_pc || !this.is_login) {
      return;
    }
    if (this.push_pop.length <= 0) {
      return;
    }

    let popover_push = this.popoverCtrl.create(
      'HomePushPage',
      {parent_page: this, push_data: this.push_pop[0]},
      {cssClass:'push_popover',enableBackdropDismiss:false}
    );
    popover_push.present();
    this.push_pop.shift();
    this.comProv.setOptions('last_push_pop_time', this.comProv.formatDate(new Date(), 'YYYY/MM/DD hh:mm:ss'));
  }

  getTopTab() {
    //console.log('is_top_tab_list', this.navCtrl['rootParams']['is_top_tab_list']);
    if (this.comProv.isPc()) {
      return;
    }
    if (!this.service_data['option']['is_top_tab']) {
      return;
    }
    if (this.service_data['option']['is_top_tab'] != '2') {
      if (!this.comProv.isLogin()) {
        return;
      }
    }
    if (this.navCtrl['rootParams']['is_top_tab_list']) {
      return;
    }
    this.navCtrl['rootParams']['is_top_tab_list'] = true;
    //console.log('home getTopTab');

    if (this.service_data['option']['is_top_tab'] == '2') {
      this.apiProv.get(this.service_data['_links']['home_tabs']['href'])
      .then(data => {
        if (data['statusCode'] != '000') {
          return;
        }
        let shop_list = data['data'];
        this.comProv.setTopTab(shop_list);
        this.comHeader.getTopTab();
      }).catch(error => {
      });
    } else {
      this.apiProv.get(this.service_data['_links']['shops']['href'], {light_mode:1})
      .then(data => {
        if (data['statusCode'] != '000') {
          return;
        }
        let shop_list = data['data'];
        this.comProv.setTopTab(shop_list);
        this.comHeader.getTopTab();
      }).catch(error => {
      });
    }
  }

  goPage(slide_data) {
    let category = 'ホーム画面スライド';
    if (slide_data['link_type'] == 1) {
      this.gaProv.trackClick(category, '外部リンク', slide_data['link_url']);
      this.comProv.checkLink(slide_data['link_url'], this.navCtrl);
    } else if (slide_data['link_type'] == 2 || slide_data['link_type'] == 3) {
      let page_name = 'EventIndexPage';
      if (slide_data['link_type'] == 2) {
        page_name = 'EventIndexPage';
      } else {
        page_name = 'CouponIndexPage';
      }

      if (this.comProv.isGoLogin(page_name)) {
        if (this.comProv.isPc()) {
          this.scrollTo(page_name);
        } else {
          this.gaProv.trackClick(category, page_name);
          this.navCtrl.setRoot(page_name);
        }
      } else {
        this.comProv.alertLogin(this.navCtrl);
      }
    }
  }

  goPageSlide() {
    let real_index = this.slides_top.realIndex;
    //console.log('real_index', real_index);
    this.goPage(this.slide_list[real_index]);
  }

  goGoogleplay() {
    this.comProv.goGoogleplay();
  }

  goAppstore() {
    this.comProv.goAppstore();
  }

  goPushDetail(data) {
    if (data['url']) {
      this.comProv.checkLink(data['url'], this.navCtrl);
    } else {
      this.navCtrl.push('PushDetailPage', {push_data:data,push_id:data.id});
    }
  }

  goCouponDetail(data) {
    this.navCtrl.push('CouponDataPage', {coupon_data:data,coupon_id:data.id});
  }

  goEventDetail(data) {
    if (data['url']) {
      this.comProv.checkLink(data['url'], this.navCtrl);
    } else {
      this.navCtrl.push('EventDetailPage', {event_data:data,event_id:data.id});
    }
  }

  goMenuDetail(data, target_id) {
    if (data['url']) {
      this.comProv.checkLink(data['url'], this.navCtrl);
    } else {
      if (!target_id) {
        target_id = 0;
      }
      this.navCtrl.push('MenuDetailPage', {menu_data:data,menu_id:data.id,target_id:target_id});
    }
  }

  // リフレッシュ
  doRefresh() {
    this.comProv.restart();
    //this.comProv.reload();
  }

  scrollTo(id, smooth=null) {
    let element = document.getElementById(id);
    if (element) {
      if (smooth) {
        element.scrollIntoView({behavior:'smooth'});
      } else {
        element.scrollIntoView();
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts